<template>
  <BaseTooltip
    :text="this.input.validations.message"
    :show="showTooltip && !input.validationBox"
    :fullWidth="!(isHalf || isOneFourth || isThreeFourth)"
    :class="{
      [$style.baseInputWrapper]: true,
      [$style.halfWidth]: isHalf,
      [$style.oneFourth]: isOneFourth,
      [$style.oneFourthNewDesign]: isOneFourth && isNewDesign,
      [$style.threeFourth]: isThreeFourth,
      [$style.threeFourthNewDesign]: isThreeFourth && isNewDesign,
      [$style.validationBox]: input.validationBox && isInvalid,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <input
      :autocomplete="stopAutocomplete && 'nope'"
      :disabled="input.disabled"
      v-model.trim="$v.selectedValue.$model"
      :placeholder="input.label"
      @change="onChange"
      @input="onInput"
      :class="{
        [$style.baseInput]: true,
        [$style.baseInputNewDesign]: isNewDesign,
        [$style.invalid]: isInvalid
      }"
    />
    <!-- error message -->
    <p :class="$style.errorMessage" v-if="isInvalid && input.validationBox">
      {{ input.validations.message }}
    </p>
  </BaseTooltip>
</template>

<script>
import store from '@/store'
import {
  noSpecialCharacters,
  minOneNumber,
  noNumber,
  phoneNumber,
  minOneAlpha,
  noSingleZero,
  addressValidation
} from '../../helpers/validation-helper'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  and,
  or
} from 'vuelidate/lib/validators'
import BaseTooltip from '@/components/ui/BaseTooltip.vue'

export default {
  props: {
    input: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseTooltip
  },
  data() {
    return {
      selectedValue: null,
      isInvalid: false,
      showTooltip: false,
      timeout: null,
      isBlur: false
    }
  },
  mixins: [validationMixin],
  validations() {
    if (this.input.validations) {
      return {
        selectedValue: {
          noSpecialCharacters: this.input.validations.noSpecialCharacters
            ? noSpecialCharacters
            : '',
          required: this.input.validations.required ? required : '',
          email: this.input.validations.email ? email : '',
          minLength: this.input.validations.minLength
            ? minLength(this.input.validations.minLength)
            : '',
          maxLength: this.input.validations.maxLength
            ? maxLength(this.input.validations.maxLength)
            : '',
          numeric: this.input.validations.numeric ? numeric : '',
          minOneNumber: this.input.validations.minOneNumber ? minOneNumber : '',
          noNumber: this.input.validations.noNumber ? noNumber : '',
          minOneAlpha: this.input.validations.minOneAlpha ? minOneAlpha : '',
          phoneNumber: this.input.validations.phoneNumber
            ? or(and(phoneNumber, noSpecialCharacters), numeric)
            : '',
          address: this.input.validations.address ? addressValidation : '',
          noSingleZero: this.input.validations.noSingleZero ? noSingleZero : ''
        }
      }
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // ON HAUSANKER (NOT ON ADDRESS SLIDES)
    stopAutocomplete() {
      return !this.input.autocomplete && this.isNewDesign
    },
    vuexInputValidate() {
      return store.state.inputValidate
    },
    isHalf() {
      return this.input.width === 'half'
    },
    isOneFourth() {
      return this.input.width === '1-4'
    },
    isThreeFourth() {
      return this.input.width === '3-4'
    },
    inputSelectedValue() {
      return this.input.selectedValue
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    onChange() {
      this.isBlur = true
      this.checkValidation()
      const data = {
        slideName: this.input.slideName,
        formName: this.input.formName,
        name: this.input.name,
        value: this.selectedValue,
        isInvalid: this.isInvalid
      }
      this.$emit('onInput', data)
    },
    onInput() {
      if (this.isBlur) {
        this.checkValidation()
      }
    },
    checkValidation() {
      if (this.$v.selectedValue.$invalid && this.$v.selectedValue.$anyDirty) {
        this.showTooltip = true
      } else {
        this.showTooltip = false
      }
      this.isInvalid = this.$v.selectedValue.$invalid ? true : false
    }
  },
  created() {
    this.selectedValue = this.input.selectedValue
  },
  watch: {
    inputSelectedValue(newValue, oldValue) {
      this.selectedValue = this.inputSelectedValue
      let isInvalid = this.$v.selectedValue.$invalid ? true : false
      if (!isInvalid) {
        this.isInvalid = false
      }

      const data = {
        slideName: this.input.slideName,
        formName: this.input.formName,
        name: this.input.name,
        value: this.selectedValue,
        isInvalid: isInvalid
      }
      this.$emit('onInput', data)
    },
    vuexInputValidate() {
      if (this.vuexInputValidate) {
        this.isBlur = true
        this.checkValidation()
        if (this.isInvalid) {
          this.showTooltip = true
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';
.baseInputWrapper {
  width: 100%;
  height: 50px;
}

// because of validation box messages
.baseInputWrapper:not(:last-child) {
  margin-bottom: 20px;
  &.validationBox {
    margin-bottom: 46px;
    &.oneFourth {
      margin-bottom: 60px;
    }
  }
}

.baseInput {
  width: 100%;
  height: 100%;
  height: 50px;
  border: 2px solid $color_grey_3;
  display: inline;
  font-size: 18px;
  color: $color_font_1;
  padding-left: 15px;
  font-family: inherit;
  box-sizing: border-box;
}

// note: new design
.baseInputNewDesign {
  border: 2px solid $color_border_new;
}

/* Chrome, Safari, Edge, Opera */
.baseInput::-webkit-outer-spin-button,
.baseInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.baseInput:focus {
  outline: none;
  border: 2px solid $color_green_2;
}

// note: new design
.baseInputNewDesign:focus {
  border: 2px solid $color_border_dark_new;
}

.halfWidth {
  width: 380px;
}

.oneFourth {
  width: 190px;
}

// note: new design
.oneFourthNewDesign {
  width: 24%;
}

.threeFourth {
  width: 570px;
}

// note: new design
.threeFourthNewDesign {
  width: 74%;
}

.invalid {
  border: 2px solid $color_error;
}

.errorMessage {
  display: block;
  color: white;
  line-height: 1.2;
  font-size: 13px;
  background-color: $color_error;
  padding: 5px 15px;
  text-align: left;
}

.baseInput::-webkit-input-placeholder {
  color: $color_font_4;
}

// note: LAND
.land {
  &.halfWidth {
    width: 49%;
  }
  &.oneFourth {
    width: 24%;
  }
  &.threeFourth {
    width: 74%;
  }
  // because of validation box messages
  &.baseInputWrapper:not(:last-child) {
    margin-bottom: 20px;
    &.validationBox {
      margin-bottom: 60px;
      &.oneFourth {
        margin-bottom: 74px;
      }
    }
  }
}

// note: PORT
.port {
  width: 100%;
  &.halfWidth {
    width: 49%;
  }
  &.oneFourth {
    width: 24%;
  }
  &.threeFourth {
    width: 74%;
  }

  // because of validation box messages
  &.baseInputWrapper:not(:last-child) {
    margin-bottom: 20px;
    &.validationBox {
      margin-bottom: 46px;
      &.oneFourth {
        margin-bottom: 60px;
      }
    }
  }
}

// note: PHONE
.phone {
  width: 100%;
  &.halfWidth {
    width: 100%;
  }
  &.oneFourth {
    width: 100%;
  }
  &.threeFourth {
    width: 100%;
  }

  // because of validation box messages
  &.baseInputWrapper:not(:last-child) {
    margin-bottom: 20px;
    &.validationBox {
      margin-bottom: 46px;
      &.oneFourth {
        margin-bottom: 46px;
      }
      &.threeFourth {
        margin-bottom: 60px;
      }
      &.halfWidth {
        margin-bottom: 46px;
      }
    }
  }
}
</style>
